import { render } from "./consignment.vue?vue&type=template&id=341ecdd2"
import script from "./consignment.vue?vue&type=script&lang=js"
export * from "./consignment.vue?vue&type=script&lang=js"

import "./consignment.vue?vue&type=style&index=0&id=341ecdd2&lang=scss"

import exportComponent from "C:\\Users\\30822\\Desktop\\LQ\\git\\度才子\\supplier_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__